import { extractPdf, extractPdfTier1, configurePdfWorker } from './pdf/index.js';
import { extractPptx } from './pptx/index.js';
import { extractDocx } from './docx/index.js';
import { UnsupportedFormatError } from './types.js';
/**
 * Universal entry point. Dispatches by detected file type.
 * - PDF → tier 2 structured (with tier 1 fallback)
 * - PPTX → tier 1 zip-based slide extraction
 * - DOCX → mammoth markdown convert
 *
 * Plain text / markdown sources skip parsing entirely; the caller can pass the
 * raw string straight to the ingest payload.
 */
export async function extract(file) {
    const fmt = detectFormat(file);
    switch (fmt) {
        case 'pdf':
            return extractPdf(file);
        case 'pptx':
            return extractPptx(file);
        case 'docx':
            return extractDocx(file);
        default:
            throw new UnsupportedFormatError(file.type || file.name);
    }
}
function detectFormat(file) {
    const lowerName = file.name.toLowerCase();
    if (file.type === 'application/pdf' || lowerName.endsWith('.pdf'))
        return 'pdf';
    if (file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
        lowerName.endsWith('.pptx')) {
        return 'pptx';
    }
    if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        lowerName.endsWith('.docx')) {
        return 'docx';
    }
    return 'unknown';
}
export { configurePdfWorker, extractPdfTier1 };
export { extractPdf, parsePdfTier2 } from './pdf/index.js';
export { extractPptx } from './pptx/index.js';
export { extractDocx } from './docx/index.js';
export { UnsupportedFormatError, ParseError } from './types.js';
//# sourceMappingURL=index.js.map